let load = require('./helpers/browser/esm-js-loader-shards')(5);
module.exports = (load("ge3AN")).then(() => parcelRequire('iiG61'));